import { Injectable } from '@angular/core';
import { Region, Bound } from '../model/region';
import { HttpClient } from '@angular/common/http';
import { catchError, map, timeout } from 'rxjs/operators';
import { ErrorHandleService } from './error-handle.service';
import { Observable } from 'rxjs';


const SERVICE_URL = 'assets/regions.json';
const CONNECTION_TIMEOUT = 30000;
@Injectable({
  providedIn: 'root'
})
export class RegionService {
  regions: Region[];
  index = +Infinity;

  constructor(
    private http: HttpClient,
    private errorHandleService: ErrorHandleService
  ) { }

  init(): Observable<Region[]> {
    return this.http.get(SERVICE_URL).pipe(
      timeout(CONNECTION_TIMEOUT),
      map((res: Region[]) => {
        return res.map(r => {
          const region = new Region();
          region.bound = new Bound(1, 1, 1, 1);
          Object.assign(region, r);
          return region;
        });
      }),
      catchError(this.errorHandleService.httpGet('init', []))
    );
  }


  private getNextPrevIndex(step: number): number {
    this.index += step;

    if (this.index >= this.regions.length) {
      this.index = 0;
    }
    if (this.index < 0) {
      this.index = this.regions.length - 1;
    }
    return this.index;
  }

  public getRegion(nextPrev = 1): Region | undefined {
    const regionIndex = this.getNextPrevIndex(nextPrev);
    return this.regions[regionIndex];
  }
}
